import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiEngine from "../../util/ApiEngine";
import { ApiKey, ApiUrl } from "../../util/Constant";
import SurveyModal from "./SurveyModal";

const HIDDEN_SESSION_KEY = "surveyFloatingButtonHidden";

/// Floating "Feedback" entry for the active survey campaign. Renders nothing for guests, when no survey is running, or after the member submitted it.
const SurveyFloatingButton = ({ platform }) => {
  const { t, i18n } = useTranslation();
  const { isLoggedIn } = useSelector((state) => state.authState);
  const [survey, setSurvey] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(sessionStorage.getItem(HIDDEN_SESSION_KEY) === "true");
  const [modalKey, setModalKey] = useState(0);

  useEffect(() => {
    if (!isLoggedIn) {
      setSurvey(null);
      setIsOpen(false);
      return;
    }
    let cancelled = false;
    ApiEngine.get(ApiUrl._API_GET_ACTIVE_SURVEY + "?languageCode=" + encodeURIComponent(i18n.language || "en")).then((responseJson) => {
      if (!cancelled && responseJson && responseJson[ApiKey._API_SUCCESS_KEY]) {
        const data = responseJson[ApiKey._API_DATA_KEY];
        setSurvey(data && data.hasSurvey ? data : null);
        setModalKey((key) => key + 1);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, i18n.language]);

  function handleSubmitted() {
    setSurvey((previous) => (previous ? { ...previous, submitted: true } : previous));
  }

  function hideButton(e) {
    e.stopPropagation();
    sessionStorage.setItem(HIDDEN_SESSION_KEY, "true");
    setIsHidden(true);
  }

  if (!isLoggedIn || !survey) {
    return null;
  }

  return (
    <>
      {!survey.submitted && !isHidden && (
        <div className={"survey-floating survey-floating--" + platform.toLowerCase()}>
          <button type="button" className="survey-floating__button" onClick={() => setIsOpen(true)} aria-label={t("SURVEY_FEEDBACK_BUTTON")}>
            <img className="survey-floating__icon" src="/img/survey/survey-floating.png" alt="" />
          </button>
          <button type="button" className="survey-floating__hide" onClick={hideButton} aria-label={t("SURVEY_HIDE_BUTTON")}>
            <i className="fas fa-times" />
          </button>
        </div>
      )}
      <SurveyModal
        key={modalKey}
        isOpen={isOpen}
        survey={survey}
        platform={platform}
        onClose={() => setIsOpen(false)}
        onSubmitted={handleSubmitted}
      />
    </>
  );
};

export default SurveyFloatingButton;
